"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionDragPreview = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SortOption = _interopRequireDefault(require("./SortOption"));
var OptionDragPreview = exports.OptionDragPreview = /*#__PURE__*/(0, _react.memo)(function OptionDragPreview(_ref) {
  var optionName = _ref.optionName,
    optionK = _ref.optionK,
    categories = _ref.categories,
    stateOptions = _ref.stateOptions,
    optionContainerOnChange = _ref.optionContainerOnChange,
    isTouchDevice = _ref.isTouchDevice;
  var previewWidth = document.getElementById("answer-option-".concat(optionK)).offsetWidth;
  var scrollWindowPercentage = .8; // the percentage of the vertical screen that triggers a scroll up or down for mobile
  var scrollByPixels = 15; // number of pixels to scroll
  var handleTouchMove = function handleTouchMove(e) {
    // pageY: touch pos relative to page
    // clientY: touch pos relative to screen
    if (e.touches[0].clientY > window.innerHeight * scrollWindowPercentage) {
      // scroll down
      window.scrollBy(0, scrollByPixels);
    } else if (e.touches[0].clientY < window.innerHeight * (1 - scrollWindowPercentage)) {
      // scroll up
      window.scrollBy(0, -1 * scrollByPixels);
    }
  };
  (0, _react.useEffect)(function () {
    window.addEventListener('touchmove', handleTouchMove);
    return function () {
      window.removeEventListener('touchmove', handleTouchMove);
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: previewWidth
    }
  }, /*#__PURE__*/_react.default.createElement(_SortOption.default, {
    optionName: optionName,
    optionK: optionK,
    categories: categories,
    stateOptions: stateOptions,
    optionContainerOnChange: optionContainerOnChange,
    isTouchDevice: isTouchDevice,
    preview: true
  }));
});